import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from '../../../../theme';
import { CloseIcon } from '../../Icon';
import Flex from '../../Flex/Flex';

const FooterBar = styled.div`
  position: fixed;
  bottom: 0;
  background:  ${theme.colors.mediumLight};
  width: 100%;
  display: flex;
  height: 140px;
  color: ${theme.colors.darker};
  align-items: normal; 
  font-size:25px;
  padding: 0 50px 0 0;
  @media (min-width: ${theme.breakpoints.desktop}) {
    width: calc(100% - 400px);
  }
`;

const ActiveRows = styled.div`
  background: ${theme.colors.primary};
  width: 100px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 20px;
  color: ${theme.colors.white};
`;

const SpanRows = styled.div`
  padding-left: 25px;
  text-align: center;
  display: flex;
  align-items: center;
  color: ${theme.colors.darker};
`;


class BulkActionsToolbar extends React.Component {
  render() {
    const selectionLength = (this.props.selections) ? this.props.selections.length : [];
    const actionBar = (
      <FooterBar>
        <ActiveRows>{selectionLength}</ActiveRows>
        <SpanRows>
          <span style={{ paddingRight: '20px' }}>
            {selectionLength > 1 ? 'items' : 'item'}
            {' '}
checked
          </span>
          {this.props.bulkActions}
        </SpanRows>
        <Flex alignItems="center" pullRight>
          <CloseIcon size="30px" color={theme.colors.primary} onClick={this.props.toggleAll} />
        </Flex>
      </FooterBar>
    );
    return (selectionLength) ? actionBar : [];
  }
}


BulkActionsToolbar.propTypes = {
  selections: PropTypes.any, // eslint-disable-line
  toggleAll: PropTypes.func, // eslint-disable-line
  bulkActions: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default BulkActionsToolbar;
